import axios from 'axios';
import { getApiLink } from '../api';

export async function contactUs(): Promise<boolean> {
    await axios.post(getApiLink('UserAccessRequest/ContactUs'));
    return true;
}
